/**
 * @generated SignedSource<<eafe79d94da40bc11a8b43a0fa0cc53f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetails_item$data = {
  readonly pdpDetailsDisplay: ReadonlyArray<{
    readonly delimiter: string | null;
    readonly detailDisplayName: string | null;
    readonly detailKey: string | null;
    readonly detailValues: ReadonlyArray<{
      readonly __typename: string;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailMovement_detailValues" | "PdpSharedDetailRingSize_detailValues" | "PdpSharedDetail_detailValues">;
    } | null> | null;
  } | null> | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_item" | "PdpSharedDetailReference_item">;
  readonly " $fragmentType": "PdpRespDetails_item";
};
export type PdpRespDetails_item$key = {
  readonly " $data"?: PdpRespDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetails_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PdpDetail",
      "kind": "LinkedField",
      "name": "pdpDetailsDisplay",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "delimiter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailDisplayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "detailValues",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedDetail_detailValues"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedDetailRingSize_detailValues"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedDetailMovement_detailValues"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailFramingOptions_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "ba81f90066d6668c697a7c11dd0fd80a";

export default node;
